<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1MxKiZ/tc-custom/cover.jpg?1684274496651?1692614730311" alt="This image is the cover for the book Carne: Parte Sedicenne"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Carne: Parte Sedicenne
      </h1>
      <p class="bookDescription body article font2">
        <i>A volte chi è scappato torna con una vendetta.</i><br/> Amy può allontanarsi da Janice, ma non si sente come una punizione che possa ottenere contro Lucian per il suo tradimento. Anche se lei giura di non volerlo mai più vedere, non sembra abbastanza buono. Deve pagare per quello che ha fatto.<br/> <b>Livello di calore:</b> caldo<br/> <i>Questa è la sedicesima puntata di una serie a episodi.</i><br/>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Sky Corgan, Daniele Giuffrè
      </h2>
      
      <p class="authorDescription body article">Sky Corgan è una delle migliori autrici di bestseller secondo USA Today. Vive in Texas, dove il sole è caldo e gli uomini sono più caldi. Quando non sta scrivendo a macchina il suo prossimo romanzo d'amore bollente, le piace pianificare le vacanze future.<br/></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Babelcube
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7714ee46